import { render, staticRenderFns } from "./codeInput.vue?vue&type=template&id=75228526&scoped=true&"
import script from "./codeInput.vue?vue&type=script&lang=ts&setup=true&"
export * from "./codeInput.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./codeInput.vue?vue&type=style&index=0&id=75228526&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75228526",
  null
  
)

export default component.exports